// extracted by mini-css-extract-plugin
module.exports = {"sect":"CardSect_sect__1YWeM","container":"CardSect_container__20jyq"};